export default "__VITE_ASSET__DsDvVLb7__"